import { formatMoney as shopifyFormatMoney } from '@shopify/theme-currency'
const settings = window.SLS_STATE
const customBadgeTags = settings?.customBadge.tags || []
const customBadgeItems = settings?.customBadge.items || []

const formatMoney = function (cents, format = settings.shopify.moneyFormat) {
  return shopifyFormatMoney(cents, format)
}

const getMemberOfferPrice = (tags, price) => {
  if (!tags.length) {
    return false
  }
  const offerTag = tags.find((item) => item.includes('members-discount:'))
  if (!offerTag) {
    return false
  } else {
    const discountFixed = offerTag.includes('$')
    const discountValue = discountFixed ? offerTag.replace('members-discount:$', '') : offerTag.replace('members-discount:', '').replace('%', '')
    return discountFixed ? price - parseFloat(discountValue) * 100 : (price / 100) * (100 - parseFloat(discountValue))
  }
}

const getProductTitle = (variant, title, weight) => {
  let productTitle = title.split(' | ')[0]

  if (weight && title.includes(weight)) {
    productTitle = productTitle.replace(' ' + weight, '')
  }

  if (variant && weight) {
    productTitle = productTitle + ' | ' + weight
  }

  return productTitle
}

const getProductSubtitle = (title) => {
  const textareaEl = document.createElement('textarea')
  textareaEl.innerHTML = title && title.includes('|') ? title.split(' | ')[1] : ''
  return textareaEl.value
}

const getBadges = (tags) => {
  const items = []

  if (tags.length) {
    for (const tag of tags) {
      const index = customBadgeTags.findIndex(i => !tag.includes('preorder') && tag === i)
      if (index !== -1) {
        items.push(
          customBadgeItems[index]
        )
      } else if (tag.includes('members-discount:')) {
        const currentIndex = customBadgeTags.findIndex(i => i.includes('members-discount:'))
        if (currentIndex !== -1) {
          items.push(
            customBadgeItems[currentIndex]
          )
        }
      } else if (tag.includes('available:')) {
        const currentValue = tag.replace('available:', '').trim()
        const etaDate = new Date(currentValue).getTime()
        const todayDate = new Date().getTime()
        if (todayDate < etaDate) {
          const dateString = new Date(etaDate).toLocaleDateString('en-EN', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          })
          items.push({
            text: `Available ${dateString}`,
            tag,
            customClass: 'badge-accent-1',
            backgroundColor: '',
            textColor: ''
          })
        }
      } else if (tag.includes('comming-soon')) {
        const currentIndex = customBadgeTags.findIndex(i => i.includes('comming-soon'))
        if (currentIndex !== -1) {
          items.push(
            customBadgeItems[currentIndex]
          )
        }
      } else if (tag.includes('unavailable-online')) {
        const currentIndex = customBadgeTags.findIndex(i => i.includes('unavailable-online'))
        if (currentIndex !== -1) {
          items.push(
            customBadgeItems[currentIndex]
          )
        }
      } else {
        if (tag.includes('label-') && customBadgeTags.includes(tag)) {
          const tagName = tag.replace('label-', '')
          items.push({
            text: tagName,
            tag,
            customClass: '',
            backgroundColor: '',
            textColor: ''
          })
        }
      }
    }
    if (tags.some(item => item.includes('preorder')) && !items.some(item => item.tag.includes('available:'))) {
      const index = customBadgeTags.findIndex(i => i.includes('preorder'))
      if (index !== -1 && !items.some(item => item.tag.includes('preorder'))) {
        items.push(
          customBadgeItems[index]
        )
      }
    }
  }

  return items
}

export {
  formatMoney,
  getMemberOfferPrice,
  getProductTitle,
  getProductSubtitle,
  getBadges
}
